{
  "three-acts": {
    "name": "Tre akter",
    "summary": "Introduktion, konfrontation och upplösning: formen som de flesta romaner och filmer delar.",
    "bestFor": "Alla genrer och ett första utkast som du vill hålla enkelt.",
    "metaTitle": "Berättelsemall i tre akter — Musael",
    "metaDescription": "Introduktion, konfrontation och upplösning: formen i de flesta romaner och filmer. För alla genrer och ett enkelt första utkast.",
    "acts": [
      {
        "title": "Akt I: Introduktion",
        "synopsis": "Vem huvudpersonen är, vad hen vill och händelsen som avslutar det vanliga livet.",
        "chapters": [
          {
            "title": "Den vanliga världen",
            "synopsis": "Huvudpersonen hemma, med längtan och svagheten som berättelsen ska pröva.",
            "scenes": [
              {
                "title": "Inledningsbild",
                "synopsis": "En ögonblicksbild av huvudpersonen innan något förändras."
              },
              {
                "title": "Kroken",
                "synopsis": "Något litet men märkligt som förebådar problem."
              }
            ]
          },
          {
            "title": "Den utlösande händelsen",
            "synopsis": "Händelsen som huvudpersonen inte kan ignorera.",
            "scenes": [
              {
                "title": "Utlösande händelse",
                "synopsis": "Problemet dyker upp och försvinner inte."
              },
              {
                "title": "Tvekan",
                "synopsis": "Huvudpersonen tvekar, och vi ser vad som står att förlora."
              }
            ]
          },
          {
            "title": "Över tröskeln",
            "synopsis": "Huvudpersonen förbinder sig; det finns ingen enkel väg tillbaka.",
            "scenes": [
              {
                "title": "Beslutet",
                "synopsis": "Huvudpersonen väljer att agera och lämnar det välbekanta bakom sig."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt II: Konfrontation",
        "synopsis": "Huvudpersonen försöker, misslyckas och lär sig medan allt mer står på spel.",
        "chapters": [
          {
            "title": "Insatserna höjs",
            "synopsis": "Nya regler, allierade och fiender; de första segrarna kostar något.",
            "scenes": [
              {
                "title": "Första prövningen",
                "synopsis": "Huvudpersonen möter den nya världen och missförstår den delvis."
              },
              {
                "title": "Allierade och fiender",
                "synopsis": "Vem hjälper, vem hindrar och varför."
              }
            ]
          },
          {
            "title": "Mittpunkten",
            "synopsis": "En vändning som förändrar vad berättelsen handlar om.",
            "scenes": [
              {
                "title": "Mittpunkt",
                "synopsis": "En skenbar seger eller ett skenbart nederlag; huvudpersonen slutar reagera och tar initiativet."
              }
            ]
          },
          {
            "title": "Allt faller samman",
            "synopsis": "Motståndet tränger sig på och svagheten kostar huvudpersonen dyrt.",
            "scenes": [
              {
                "title": "Snaran dras åt",
                "synopsis": "Varje plan möter motstånd; relationerna spricker."
              },
              {
                "title": "Allt är förlorat",
                "synopsis": "Bottenläget: målet verkar för alltid utom räckhåll."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt III: Upplösning",
        "synopsis": "Huvudpersonen förändras, möter den sista prövningen och ett nytt normalt liv börjar.",
        "chapters": [
          {
            "title": "Klimax",
            "synopsis": "Den sista konfrontationen, vunnen tack vare lärdomen från akt II.",
            "scenes": [
              {
                "title": "Den sista planen",
                "synopsis": "Huvudpersonen samlar det hen har lärt sig och gör ett sista försök."
              },
              {
                "title": "Klimax",
                "synopsis": "Den avgörande konfrontationen."
              }
            ]
          },
          {
            "title": "Det nya normala",
            "synopsis": "Vad som förändrats, för huvudpersonen och för världen.",
            "scenes": [
              {
                "title": "Avslutningsbild",
                "synopsis": "En spegling av inledningsbilden som visar hur långt huvudpersonen har kommit."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "Hjältens resa",
    "summary": "Tolv steg från kallelsen till äventyret till hemkomsten, indelade i avfärd, invigning och återkomst.",
    "bestFor": "Fantasy, äventyr och uppdrag.",
    "metaTitle": "Berättelsemall för hjältens resa — Musael",
    "metaDescription": "Tolv steg från kallelsen till äventyret till hemkomsten: avfärd, invigning och återkomst. För fantasy, äventyr och uppdrag.",
    "acts": [
      {
        "title": "Avfärd",
        "synopsis": "Huvudpersonen lämnar den kända världen.",
        "chapters": [
          {
            "title": "Den vanliga världen",
            "synopsis": "Huvudpersonen före äventyret: hem, vanor och det som saknas.",
            "scenes": [
              {
                "title": "Den vanliga världen",
                "synopsis": "Huvudpersonen före äventyret: hem, vanor och det som saknas."
              }
            ]
          },
          {
            "title": "Kallelsen till äventyret",
            "synopsis": "En utmaning eller ett meddelande stör den vanliga världen.",
            "scenes": [
              {
                "title": "Kallelsen till äventyret",
                "synopsis": "En utmaning eller ett meddelande stör den vanliga världen."
              }
            ]
          },
          {
            "title": "Avvisad kallelse",
            "synopsis": "Rädsla eller plikt håller huvudpersonen tillbaka.",
            "scenes": [
              {
                "title": "Avvisad kallelse",
                "synopsis": "Rädsla eller plikt håller huvudpersonen tillbaka."
              }
            ]
          },
          {
            "title": "Mötet med mentorn",
            "synopsis": "Någon ger råd, träning eller en gåva.",
            "scenes": [
              {
                "title": "Mötet med mentorn",
                "synopsis": "Någon ger råd, träning eller en gåva."
              }
            ]
          },
          {
            "title": "Över den första tröskeln",
            "synopsis": "Huvudpersonen kliver in i den särskilda världen.",
            "scenes": [
              {
                "title": "Över den första tröskeln",
                "synopsis": "Huvudpersonen kliver in i den särskilda världen."
              }
            ]
          }
        ]
      },
      {
        "title": "Invigning",
        "synopsis": "Prövningar i den särskilda världen och det stora eldprovet.",
        "chapters": [
          {
            "title": "Prövningar, allierade och fiender",
            "synopsis": "Huvudpersonen lär sig den nya världens regler.",
            "scenes": [
              {
                "title": "Prövningar, allierade och fiender",
                "synopsis": "Huvudpersonen lär sig den nya världens regler."
              }
            ]
          },
          {
            "title": "Närmandet till den innersta grottan",
            "synopsis": "Förberedelser inför den centrala faran.",
            "scenes": [
              {
                "title": "Närmandet till den innersta grottan",
                "synopsis": "Förberedelser inför den centrala faran."
              }
            ]
          },
          {
            "title": "Eldprovet",
            "synopsis": "En kris på liv och död; något inom huvudpersonen dör.",
            "scenes": [
              {
                "title": "Eldprovet",
                "synopsis": "En kris på liv och död; något inom huvudpersonen dör."
              }
            ]
          },
          {
            "title": "Belöningen",
            "synopsis": "Huvudpersonen tar skatten, kunskapen eller försoningen.",
            "scenes": [
              {
                "title": "Belöningen",
                "synopsis": "Huvudpersonen tar skatten, kunskapen eller försoningen."
              }
            ]
          }
        ]
      },
      {
        "title": "Återkomst",
        "synopsis": "Vägen hem, en sista prövning och det som huvudpersonen tar med sig tillbaka.",
        "chapters": [
          {
            "title": "Vägen tillbaka",
            "synopsis": "Huvudpersonen vänder hemåt, ofta förföljd.",
            "scenes": [
              {
                "title": "Vägen tillbaka",
                "synopsis": "Huvudpersonen vänder hemåt, ofta förföljd."
              }
            ]
          },
          {
            "title": "Återuppståndelse",
            "synopsis": "En sista prövning där allt det inlärda kommer till användning.",
            "scenes": [
              {
                "title": "Återuppståndelse",
                "synopsis": "En sista prövning där allt det inlärda kommer till användning."
              }
            ]
          },
          {
            "title": "Hemkomst med elixiret",
            "synopsis": "Huvudpersonen kommer hem förändrad, med något att dela med sig av.",
            "scenes": [
              {
                "title": "Hemkomst med elixiret",
                "synopsis": "Huvudpersonen kommer hem förändrad, med något att dela med sig av."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Disposition i femton steg",
    "summary": "Manusförfattarnas schema: femton vändpunkter fördelade på tre akter.",
    "bestFor": "Täta, kommersiella intriger med tydliga vändpunkter.",
    "metaTitle": "Berättelsemall i femton steg — Musael",
    "metaDescription": "Manusförfattarnas schema: femton vändpunkter i tre akter. För täta, kommersiella intriger med tydliga vändpunkter.",
    "acts": [
      {
        "title": "Akt I",
        "synopsis": "Världen före och valet att lämna den.",
        "chapters": [
          {
            "title": "Inledningsbild",
            "synopsis": "Huvudpersonen och världen före berättelsen.",
            "scenes": [
              {
                "title": "Inledningsbild",
                "synopsis": "Huvudpersonen och världen före berättelsen."
              }
            ]
          },
          {
            "title": "Temat uttalas",
            "synopsis": "Någon säger vad berättelsen egentligen handlar om; huvudpersonen förstår det inte än.",
            "scenes": [
              {
                "title": "Temat uttalas",
                "synopsis": "Någon säger vad berättelsen egentligen handlar om; huvudpersonen förstår det inte än."
              }
            ]
          },
          {
            "title": "Introduktion",
            "synopsis": "Huvudpersonens liv, människorna i det och det som behöver rättas till.",
            "scenes": [
              {
                "title": "Introduktion",
                "synopsis": "Huvudpersonens liv, människorna i det och det som behöver rättas till."
              }
            ]
          },
          {
            "title": "Katalysator",
            "synopsis": "Händelsen som sätter berättelsen i rörelse.",
            "scenes": [
              {
                "title": "Katalysator",
                "synopsis": "Händelsen som sätter berättelsen i rörelse."
              }
            ]
          },
          {
            "title": "Tvekan",
            "synopsis": "Huvudpersonen tvivlar på vad hen ska göra.",
            "scenes": [
              {
                "title": "Tvekan",
                "synopsis": "Huvudpersonen tvivlar på vad hen ska göra."
              }
            ]
          },
          {
            "title": "In i andra akten",
            "synopsis": "Huvudpersonen väljer en ny väg.",
            "scenes": [
              {
                "title": "In i andra akten",
                "synopsis": "Huvudpersonen väljer en ny väg."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt II",
        "synopsis": "Premissens löfte, sedan fallet.",
        "chapters": [
          {
            "title": "Bihandling",
            "synopsis": "En sekundär berättelse, ofta en relation, som bär temat.",
            "scenes": [
              {
                "title": "Bihandling",
                "synopsis": "En sekundär berättelse, ofta en relation, som bär temat."
              }
            ]
          },
          {
            "title": "Lek och spel",
            "synopsis": "Premissen infrias: det som läsarna kom för.",
            "scenes": [
              {
                "title": "Lek och spel",
                "synopsis": "Premissen infrias: det som läsarna kom för."
              }
            ]
          },
          {
            "title": "Mittpunkt",
            "synopsis": "En skenbar seger eller ett skenbart nederlag höjer insatserna.",
            "scenes": [
              {
                "title": "Mittpunkt",
                "synopsis": "En skenbar seger eller ett skenbart nederlag höjer insatserna."
              }
            ]
          },
          {
            "title": "Motståndarna närmar sig",
            "synopsis": "Tvivel inifrån, press utifrån.",
            "scenes": [
              {
                "title": "Motståndarna närmar sig",
                "synopsis": "Tvivel inifrån, press utifrån."
              }
            ]
          },
          {
            "title": "Allt är förlorat",
            "synopsis": "Motsatsen till mittpunkten: det djupaste bottenläget.",
            "scenes": [
              {
                "title": "Allt är förlorat",
                "synopsis": "Motsatsen till mittpunkten: det djupaste bottenläget."
              }
            ]
          },
          {
            "title": "Själens mörka natt",
            "synopsis": "Huvudpersonen sörjer det förlorade och hittar lärdomen.",
            "scenes": [
              {
                "title": "Själens mörka natt",
                "synopsis": "Huvudpersonen sörjer det förlorade och hittar lärdomen."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt III",
        "synopsis": "Lärdomen omsätts i handling.",
        "chapters": [
          {
            "title": "In i tredje akten",
            "synopsis": "En ny idé från bihandlingen öppnar en väg.",
            "scenes": [
              {
                "title": "In i tredje akten",
                "synopsis": "En ny idé från bihandlingen öppnar en väg."
              }
            ]
          },
          {
            "title": "Final",
            "synopsis": "Huvudpersonen lagar det som var trasigt, förändrad för gott.",
            "scenes": [
              {
                "title": "Final",
                "synopsis": "Huvudpersonen lagar det som var trasigt, förändrad för gott."
              }
            ]
          },
          {
            "title": "Slutbild",
            "synopsis": "Världen efteråt, som speglar inledningsbilden.",
            "scenes": [
              {
                "title": "Slutbild",
                "synopsis": "Världen efteråt, som speglar inledningsbilden."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Sjupunktsstruktur",
    "summary": "Planera bakåt från slutet: krok, vändningar, tryckpunkter, mittpunkt och upplösning.",
    "bestFor": "Författare som känner till slutet först.",
    "metaTitle": "Berättelsemall med sju punkter — Musael",
    "metaDescription": "Planera bakåt från slutet: krok, vändningar, tryckpunkter, mittpunkt och upplösning. För författare som känner till slutet först.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Krok",
            "synopsis": "Utgångsläget, motsatsen till upplösningen.",
            "scenes": [
              {
                "title": "Krok",
                "synopsis": "Utgångsläget, motsatsen till upplösningen."
              }
            ]
          },
          {
            "title": "Handlingsvändning 1",
            "synopsis": "Konflikten börjar och huvudpersonen drivs till handling.",
            "scenes": [
              {
                "title": "Handlingsvändning 1",
                "synopsis": "Konflikten börjar och huvudpersonen drivs till handling."
              }
            ]
          },
          {
            "title": "Tryckpunkt 1",
            "synopsis": "Antagonisten sätter press; huvudpersonen måste agera.",
            "scenes": [
              {
                "title": "Tryckpunkt 1",
                "synopsis": "Antagonisten sätter press; huvudpersonen måste agera."
              }
            ]
          },
          {
            "title": "Mittpunkt",
            "synopsis": "Huvudpersonen går från att reagera till att agera.",
            "scenes": [
              {
                "title": "Mittpunkt",
                "synopsis": "Huvudpersonen går från att reagera till att agera."
              }
            ]
          },
          {
            "title": "Tryckpunkt 2",
            "synopsis": "Allt går riktigt illa; planen misslyckas.",
            "scenes": [
              {
                "title": "Tryckpunkt 2",
                "synopsis": "Allt går riktigt illa; planen misslyckas."
              }
            ]
          },
          {
            "title": "Handlingsvändning 2",
            "synopsis": "Huvudpersonen får den sista pusselbiten som behövs för att vinna.",
            "scenes": [
              {
                "title": "Handlingsvändning 2",
                "synopsis": "Huvudpersonen får den sista pusselbiten som behövs för att vinna."
              }
            ]
          },
          {
            "title": "Upplösning",
            "synopsis": "Slutläget, svaret på kroken.",
            "scenes": [
              {
                "title": "Upplösning",
                "synopsis": "Slutläget, svaret på kroken."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Fyra rörelser byggda kring en vändning i stället för en konflikt.",
    "bestFor": "Litterär fiktion, noveller och lågmälda, karaktärsdrivna böcker.",
    "metaTitle": "Berättelsemall för Kishōtenketsu — Musael",
    "metaDescription": "Fyra rörelser kring en vändning i stället för en konflikt. För litterär fiktion, noveller och lågmälda, karaktärsdrivna böcker.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: introduktion",
            "synopsis": "Personerna och deras värld, i lugn takt.",
            "scenes": [
              {
                "title": "Introduktion",
                "synopsis": "Vem, var och hur vardagen ser ut."
              }
            ]
          },
          {
            "title": "Shō: utveckling",
            "synopsis": "Situationen fördjupas, ännu utan någon vändning.",
            "scenes": [
              {
                "title": "Utveckling",
                "synopsis": "Vi lär känna personerna bättre; små saker förskjuts."
              }
            ]
          },
          {
            "title": "Ten: vändning",
            "synopsis": "Ett oväntat inslag förändrar hur vi ser på allt.",
            "scenes": [
              {
                "title": "Vändningen",
                "synopsis": "Något nytt dyker upp, till synes utan koppling."
              }
            ]
          },
          {
            "title": "Ketsu: sammanfogning",
            "synopsis": "Delarna förenas till en ny förståelse.",
            "scenes": [
              {
                "title": "Sammanfogning",
                "synopsis": "Vändningen möter berättelsen; betydelsen förändras."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Deckare",
    "summary": "Ett brott, en utredning med ledtrådar och villospår och ett avslöjande som är rättvist mot läsaren.",
    "bestFor": "Kriminalromaner, detektivhistorier och mysdeckare.",
    "metaTitle": "Berättelsemall för deckare — Musael",
    "metaDescription": "Ett brott, ledtrådar, villospår och ett rättvist avslöjande. För kriminalromaner, detektivhistorier och mysdeckare.",
    "acts": [
      {
        "title": "Brottet",
        "synopsis": "Något är fel, och någon måste ta reda på varför.",
        "chapters": [
          {
            "title": "Upptäckten",
            "synopsis": "Brottet eller försvinnandet.",
            "scenes": [
              {
                "title": "Kroppen",
                "synopsis": "Brottet upptäcks; första intryck och första frågor."
              },
              {
                "title": "Utredaren",
                "synopsis": "Vem som utreder och varför det spelar roll för den personen."
              }
            ]
          }
        ]
      },
      {
        "title": "Utredningen",
        "synopsis": "Ledtrådar, misstänkta och villospår.",
        "chapters": [
          {
            "title": "Misstänkta",
            "synopsis": "Alla med ett motiv och ett alibi.",
            "scenes": [
              {
                "title": "Samtal",
                "synopsis": "Varje misstänkt får en anledning att ljuga."
              },
              {
                "title": "Den första ledtråden",
                "synopsis": "Ett faktum som blir viktigt senare; spela ärligt med läsaren."
              }
            ]
          },
          {
            "title": "Villospår",
            "synopsis": "Utredningen går åt fel håll.",
            "scenes": [
              {
                "title": "En falsk ledtråd",
                "synopsis": "Bevisen pekar på fel person."
              },
              {
                "title": "Upptrappning",
                "synopsis": "Ett andra brott eller ett hot höjer insatserna."
              }
            ]
          },
          {
            "title": "Den dolda sanningen",
            "synopsis": "Utredaren ser det som alltid har funnits där.",
            "scenes": [
              {
                "title": "Den saknade pusselbiten",
                "synopsis": "En liten detalj får de tidigare ledtrådarna att passa ihop."
              }
            ]
          }
        ]
      },
      {
        "title": "Avslöjandet",
        "synopsis": "Lösningen och dess pris.",
        "chapters": [
          {
            "title": "Lösningen",
            "synopsis": "Varje ledtråd förklaras.",
            "scenes": [
              {
                "title": "Avslöjandet",
                "synopsis": "Den skyldiga pekas ut och resonemanget läggs fram."
              },
              {
                "title": "Efterdyningarna",
                "synopsis": "Rättvisa, eller avsaknaden av den, och vad utredaren bär med sig."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Romantik",
    "summary": "Två personer, det som håller dem isär och vad som krävs för att välja varandra.",
    "bestFor": "Romantik och kärlekshistorier i alla miljöer.",
    "metaTitle": "Berättelsemall för romantik — Musael",
    "metaDescription": "Två personer, vad som håller dem isär och vad som krävs för att välja varandra. För romantik och kärlekshistorier i alla miljöer.",
    "acts": [
      {
        "title": "Förälskelse",
        "synopsis": "De möts, gör motstånd och börjar bli kära.",
        "chapters": [
          {
            "title": "Mötet",
            "synopsis": "Det första mötet, med gnistan och hindret.",
            "scenes": [
              {
                "title": "Möte",
                "synopsis": "De två huvudpersonerna möts; något hos den andra går dem under huden."
              },
              {
                "title": "Motstånd",
                "synopsis": "Varför det inte kan fungera: mål, sår eller omständigheter."
              }
            ]
          },
          {
            "title": "Närmare varandra",
            "synopsis": "Tvingade att vara tillsammans ser de varandra på riktigt.",
            "scenes": [
              {
                "title": "Tillsammans av en slump",
                "synopsis": "En situation håller dem nära."
              },
              {
                "title": "Det första äkta ögonblicket",
                "synopsis": "En glimt av vem den andra verkligen är."
              }
            ]
          }
        ]
      },
      {
        "title": "Tvivel",
        "synopsis": "Ett åtagande, sedan rädslan som bryter det.",
        "chapters": [
          {
            "title": "Mittpunkten",
            "synopsis": "De ger efter för sina känslor.",
            "scenes": [
              {
                "title": "Åtagande",
                "synopsis": "En kyss, ett erkännande eller ett löfte."
              }
            ]
          },
          {
            "title": "Brytningen",
            "synopsis": "Det gamla såret eller det yttre hindret vinner, för tillfället.",
            "scenes": [
              {
                "title": "Tveksamhet",
                "synopsis": "Gamla rädslor återvänder."
              },
              {
                "title": "Uppbrottet",
                "synopsis": "De skiljs åt, båda övertygade om att ha rätt."
              }
            ]
          }
        ]
      },
      {
        "title": "Valet",
        "synopsis": "Utveckling, en stor gest och en gemensam framtid.",
        "chapters": [
          {
            "title": "Tillsammans",
            "synopsis": "Båda förändras tillräckligt för att förtjäna den andra.",
            "scenes": [
              {
                "title": "Den stora gesten",
                "synopsis": "En av dem riskerar allt för att visa sin förändring."
              },
              {
                "title": "Lyckliga i alla sina dagar",
                "synopsis": "Eller lyckliga för stunden: framtiden de väljer."
              }
            ]
          }
        ]
      }
    ]
  }
}
